// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/currency-dollar.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'currency-dollar',
  version: 'outline',
  paths: [
    {
      d: 'M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
    },
  ],
}
